export default {
  data() {
    return {
      USER_MIXIN_NAMESPACE: "",
      colors: [
        "red",
        "indigo",
        "green",
        "blue",
        "purple",
        "cyan",
        "teal",
        "brown",
        "lime",
        "yellow",
        "pink",
        "blue-grey",
        "orange"
      ],
      fab: false,
      search: null,
      selected: false
    };
  },
  methods: {
    add() {
      let user = { editMode: true };
      return this.$store
        .dispatch(`${this.USER_MIXIN_NAMESPACE}/selectUser`, user)
        .then(res => {
          this.$emit("userEdit", 1);
        });
    },
    edit(user) {
      return this.$store
        .dispatch(`${this.USER_MIXIN_NAMESPACE}/selectUser`, user)
        .then(res => {
          this.$emit("userEdit");
        });
    },
    getColor(clientId) {
      return this.colors[clientId % 13];
    },
    loadClients() {
      return this.$store.dispatch(
        `${this.USER_MIXIN_NAMESPACE}/loadClientList`
      );
    },
    loadUsers() {
      return this.$store.dispatch(`${this.USER_MIXIN_NAMESPACE}/loadUsers`);
    },
    userHover(user, hover) {
      user.hover = hover;
      this.$forceUpdate();
    }
  }
};
